// @flow

export type ToggleTypeaheadOverlay = {
  type: 'TOGGLE_TYPEAHEAD_OVERLAY',
  payload: {
    value: boolean,
  },
};

export const toggleTypeaheadOverlay = (value: boolean): ToggleTypeaheadOverlay => ({
  type: 'TOGGLE_TYPEAHEAD_OVERLAY',
  payload: {
    value,
  },
});

/**
 * Action to set the global current video playing (either autoplaying from grid, or visible video closeup)
 */
export type SetCurrentVideo = {
  type: 'SET_CURRENT_VIDEO',
  payload: { pinId: string, isPromoted: boolean, currentTime: ?number },
};

export type SetVideoParams = {|
  pinId: string,
  isPromoted: boolean,
  currentTime?: ?number,
|};

export function setCurrentVideo(setVideoParams: SetVideoParams): SetCurrentVideo {
  const { currentTime, isPromoted, pinId } = setVideoParams;
  return { type: 'SET_CURRENT_VIDEO', payload: { pinId, isPromoted, currentTime } };
}

export type SetIsAutoplay = {
  type: 'SET_IS_AUTOPLAY',
  payload: { isAutoplay: boolean },
};

export function setIsAutoplay(isAutoplay: boolean): SetIsAutoplay {
  return { type: 'SET_IS_AUTOPLAY', payload: { isAutoplay } };
}

export type SetVideoPauseStateParams = {|
  pinId: string,
  isPromoted: boolean,
  currentTime?: ?number,
|};

export type PauseAutoplay = {
  type: 'PAUSE_CURRENT_VIDEO',
  payload: { currentTime: ?number, pinId: string, isPromoted: boolean },
};

export function pauseAutoplay(setVideoPauseState: SetVideoPauseStateParams): PauseAutoplay {
  const { currentTime, isPromoted, pinId } = setVideoPauseState;
  return { type: 'PAUSE_CURRENT_VIDEO', payload: { currentTime, pinId, isPromoted } };
}

export type AppFocusState = {
  type: 'SET_APP_FOCUS_STATE',
  payload: { appInFocus: boolean },
};

export function setAppFocusState(appInFocus: boolean): AppFocusState {
  return { type: 'SET_APP_FOCUS_STATE', payload: { appInFocus } };
}
